module.exports = __webpack_public_path__ + "img/samus-min.53b9f942.png";